import { takeLatest} from 'redux-saga/effects';

import { READ_LEADERBOARD } from '../Types/Leaderboard';
import { LOGIN } from '../Types/User';
import { leaderboardReadSaga } from "./leaderboardSagas";
import { userLoginSaga} from "./userSagas";
export default function* rootSaga() {
    yield takeLatest(LOGIN, userLoginSaga);
    yield takeLatest(READ_LEADERBOARD, leaderboardReadSaga);
   
}


// WEBPACK FOOTER //
// ./src/Sagas/rootSaga.js